import React, { useContext } from 'react';
import { AHUD } from '@swegon-core/ui-components';
import { Point } from './Point.jsx';
import { Line } from './Line.jsx';
import { Container } from './Points.styles.js';
import { Droppable } from '@hello-pangea/dnd';
import { Context as TranslationContext } from '../../modules/Translation/TranslationContext.jsx';
import { Context as SettingsContext } from '../../modules/Settings/SettingsContext.jsx';
import { hasMixing, getNextPoint } from '../../lib/dataFunctions.js';
import { COLORS } from '../../lib/constants.js';

export const Points = ({ points, lines, mixings, deletePoint, toggleAddPoint }) => {
    const { l } = useContext(TranslationContext);
    const { isExternalApplication } = useContext(SettingsContext);
    const { ExpansionPanel } = AHUD;

    const hasPointAfter = point => {
        return points.indexOf(point) + 1 < points.length;
    };

    const getLineColor = key => {
        const index = parseInt(key);
        return points[index + 1].color;
    };

    return (
        <ExpansionPanel
            testid='pointsExpansionPanel'
            label={l('points.title')}
            showButton={isExternalApplication}
            tooltip={l('points.addPoint')}
            onClick={toggleAddPoint}
        >
            <Droppable droppableId='droppablePoints'>
                {(provided, snapshot) => (
                    <Container
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        isDraggingOver={snapshot.isDraggingOver}
                        data-testid='listOfPoints'
                    >
                        {Object.entries(points).map(([key, point]) => (
                            <React.Fragment key={key}>
                                <Point
                                    point={point}
                                    index={Number(key)}
                                    deletePoint={() => deletePoint(key)}
                                    editPoint={() => {
                                        toggleAddPoint(point);
                                    }}
                                />

                                {hasMixing(point, points) && !isExternalApplication && (
                                    <Line
                                        line={mixings.find(
                                            m => m.to === getNextPoint(point, points),
                                        )}
                                        index={Number(key)}
                                        color={COLORS.purple}
                                        isDashed={true}
                                    />
                                )}

                                {point.lineToNext && hasPointAfter(point) && (
                                    <Line
                                        line={lines[key]}
                                        index={Number(key)}
                                        color={getLineColor(key)}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                        {provided.placeholder}
                    </Container>
                )}
            </Droppable>
        </ExpansionPanel>
    );
};
